var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"title":"Lyrics"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.song.lyrics),expression:"song.lyrics"}],attrs:{"readonly":""},domProps:{"value":(_vm.song.lyrics)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.song, "lyrics", $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf66897c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewSong/Lyrics.vue
// module id = null
// module chunks = 